import { useState } from "react";
import styled from "styled-components";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";

const Titulo = styled.p`
    margin: 0 0 8px 0;
    font-size: 12px;
    font-weight: 700;
    color: #64748b;
`;
const Input = styled.input`
    width: 100%;
    box-sizing: border-box;
    padding: 10px 12px;
    border: 1px solid #94a3b8;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    &:focus {
        border-color: #2563eb;
        box-shadow: 0 0 0 1px #2563eb;
    }
`;
const BotaoSalvar = styled.button`
    margin-top: 14px;
    width: 100%;
    padding: 10px;
    border: none;
    border-radius: 8px;
    background-color: #263B4B;
    color: #fff;
    font-weight: 700;
    font-size: 13px;
    cursor: pointer;
    &:disabled {
        opacity: .5;
        cursor: not-allowed;
    }
    &:hover:not(:disabled) {
        background-color: #1d2f3d;
    }
`;

const ModalCelulaHorario = ({ valor, onSave, onClose }) => {

    const [horario, setHorario] = useState(valor || "");

    return (
        <Overlay state={true} changeContent={onClose}>
            <Modal header={true} close={onClose} size="sm">
                <Titulo>HORÁRIO</Titulo>
                <Input
                    type="datetime-local"
                    value={horario}
                    onChange={(e) => setHorario(e.target.value)}
                />
                <BotaoSalvar
                    disabled={!horario}
                    onClick={() => onSave(horario)}
                >
                    SALVAR
                </BotaoSalvar>
            </Modal>
        </Overlay>
    )

}

export default ModalCelulaHorario;
